export default (function(w, d, $, _, undefined){

	// Internal Properties.
	var _config = {
			userMetaData: {
				// These properties are filtered out when exposing user object to external sources.
				internal: ['authed', 'authedNetworks'],

				// These properties are required, and will generate an error if not set.
				required: ['id', 'firstName', 'lastName', 'email', 'network']
			},

			// When validating the social network, ensure it is one of the following.
			validNetworks: []
		},
		_user = {
			id: null,
			firstName: null,
			lastName: null,
			email: null,
			authed: false,
			authedNetworks: {},
			network: null,
			associatedData: {}
		},
		_userMetaData = {
			// These properties are filtered out when exposing user object to external sources.
			internal: ['authed', 'authedNetworks'],

			// These properties are required, and will generate an error if not set.
			required: ['id', 'firstName', 'lastName', 'email', 'network']
		},
		_errors = [],

	// Internal Methods
		init = function(config){
			// Merge config.
			_.extend(_config, config);
		},

	// Acccessors.
		get = function(options){
			var user = _user;

			// If we were passed options.
			if (typeof(options) !== 'undefined') {
				// Filter properties for external use.
				if (options.hasOwnProperty('filterExternal')) {
					user = _.omit(user, _config.userMetaData.internal);
				}
			}

			return user;
		},

		getError = function(){
			var errorString = _errors.join(', ');
			return errorString;
		},

	// Mutatators.
		set = function(user){
			// Sanitize/validate the incoming user object.
			var valid = _validate(user);

			// If all validity checks pass, store the user.
			if (valid) {
				_user = user;
			}

			return valid;
		},
		_validate = function(user){
			var valid = true;

			// Reset errors.
			_errors = [];

			// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
			// Ensure no additional keys are present.
			var _keys = Object.keys(_user).sort();
			var keys = Object.keys(user).sort();
			var invalidKeys = [];
			_.each(keys, function(key){
				if (_keys.indexOf(key) === -1) {
					valid = false;
					invalidKeys.push(key);
				}
			});
			if (invalidKeys.length > 0) {
				_errors.push('Invalid additional properties found (' + invalidKeys.join(',') + '). Please use associateData object to store additional properties.');
			}

			// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
			// Ensure that all required keys exist and have been set.
			var requiredFields = [];

			var fieldIsSet = function(key){
				var isSet = false;

				if (user.hasOwnProperty(key) && user[key] !== null) {
					var val = String(user[key]);

					if (/([^\s])/.test(val)) {
						isSet = true;
					}
				}

				return isSet;
			};

			// Allow complete name (firstname + lastname) OR email address to validate.
			if (fieldIsSet('email')) {
				requiredFields = _.without(_config.userMetaData.required, 'firstName', 'lastName');
			}
			else {
				requiredFields = _.without(_config.userMetaData.required, 'email');
			}

			var requiredKeys = [];
			_.each(requiredFields, function(key){
				if (!fieldIsSet(key)) {
					valid = false;
					requiredKeys.push(key);
				}
			});
			if (requiredKeys.length > 0) {
				_errors.push('Required properties missing (' + requiredKeys.join(',') + ')');
			}

			// Ensure that network is valid.
			var isSupportedSocialNetwork = (_.indexOf(_config.validNetworks, user.associatedData.ngxId) !== -1) ? true : false;
			var isSiteNetwork = (user.associatedData.ngxId === 'site') ? true : false;
			if (!isSupportedSocialNetwork && !isSiteNetwork) {
				valid = false;
				_errors.push('Network: "' + user.network + '" is not supported. Must be one of: (' + _config.validNetworks.join(',') + ',site)');
			}
			else {
				// If social network.
				if (isSupportedSocialNetwork) {
					// Ensure supplied user id is an integer string (a string containing only integers!).
					var integerRegex = /^[0-9]+$/;
					if (!_.isString(user.id) || !integerRegex.test(user.id)) {
						valid = false;
						_errors.push('User ID "' + user.id + '" for network: "' + user.network + '" must be a string containing only integers');
					}
				}
			}

			// Ensure that avatar url is valid.
			if (!_.isUndefined(user.associatedData.avatarUrl)) {
				if (/([^\s])/.test(user.associatedData.avatarUrl)) {
					if ((user.associatedData.avatarUrl.substring(0, 2) !== '//') && (user.associatedData.avatarUrl.substring(0, 8) !== 'https://')) {
						valid = false;
						_errors.push('Avatar URL invalid: "' + user.associatedData.avatarUrl + '" (Must start with "//" or "https://")');
					}
				}
			}

			return valid;
		},

		setId = function(id){
			_user.id = id;
		},

		setFirstName = function(firstName){
			_user.firstName = firstName;
		},

		setLastName = function(lastName){
			_user.lastName = lastName;
		},

		setEmail = function(email){
			_user.email = email;
		},

		setAuthed = function(authed){
			_user.authed = authed;
		},

		addAuthedNetwork = function(authedNetwork){
			var networkData = {};
			networkData[authedNetwork.network] = {};
			networkData[authedNetwork.network]['response'] = authedNetwork.data;

			_user.authedNetworks = _.extend(_user.authedNetworks, networkData);
			_user.network = authedNetwork.network;
		},
		addAuthedNetworkUser = function(authedNetworkUser){
			var networkUserData = {};
			networkUserData = {};
			networkUserData['user'] = authedNetworkUser.data;

			_user.authedNetworks[authedNetworkUser.network] = _.extend(_user.authedNetworks[authedNetworkUser.network], networkUserData);
		},

		addAssociatedData = function(associatedData){
			_user.associatedData = _.extend(_user.associatedData, associatedData);
		};

	// Public API
	return {
		init: init,

		set: set,
		get: get,
		getError: getError,

		setId: setId,
		setFirstName: setFirstName,
		setLastName: setLastName,
		setEmail: setEmail,
		setAuthed: setAuthed,
		addAuthedNetwork: addAuthedNetwork,
		addAuthedNetworkUser: addAuthedNetworkUser,
		addAssociatedData: addAssociatedData
	};

}(window, document, jQuery, _));
